type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const CustomerStatus = Object.freeze({
  active: 1 as const,
  inactive: 2 as const,
});

export type CustomerStatus = EnumLiteralsOf<typeof CustomerStatus>;
